import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Contacto } from '../models/contacto';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ContactoService {

  ServerUrl = 'http://ledlar.com.ar';
  errorData: {};

  httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  };

  constructor(private http: HttpClient, private toastr: ToastrService) { }

  contactForm(formdata: Contacto) {
    this.toastr.success('Su consulta fue enviada', 'Gracias', {
      positionClass: 'toast-bottom-center'
    });
    return this.http.post<Contacto>(this.ServerUrl + '/email.php', formdata, this.httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  contactForm2(formdata: Contacto) {
    this.toastr.success('Su consulta fue enviada', 'Gracias', {
      positionClass: 'toast-bottom-center'
    });
    return this.http.post<Contacto>(this.ServerUrl + '/email2.php', formdata, this.httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {

      // A client-side or network error occurred. Handle it accordingly.

      console.error('An error occurred:', error.error.message);
    } else {

      // The backend returned an unsuccessful response code.

      // The response body may contain clues as to what went wrong.

      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }

    // return an observable with a user-facing error message

    this.errorData = {
      errorTitle: 'Oops! No se encontró el documento referido',
      errorDesc: 'No se realizó la operación. Por favor intentele más tarde'
    };
    return throwError(this.errorData);
  }
}
